import React from 'react';
import dayjs from 'dayjs';
import { TTransactionHistoryDataTransaction } from 'store/api/cuverse-api/transaction/types/transaction-history-response.interface';

import { SSpinnerBlue } from 'components/styled/SSpinnerBlue';
import { TransactionTypeBadge } from 'components/ui/TransactionTypeBadge';
import { getTHistoryDescriptionTranslations } from 'utils/translations/translations';

import * as S from './DesktopList.styled';

interface IDesktopListProps {
  isPending: boolean;
  listRef: React.MutableRefObject<HTMLTableElement | HTMLUListElement | null>;
  slicedItems: TTransactionHistoryDataTransaction;
  t: (key: string) => string;
}

export const DesktopList: React.FC<IDesktopListProps> = ({
  isPending,
  listRef,
  slicedItems,
  t,
}) => {
  return (
    <S.TransactionsList ref={listRef as React.MutableRefObject<HTMLTableElement>}>
      {isPending ? (
        <SSpinnerBlue />
      ) : (
        <tbody>
          {slicedItems?.map(({ category, title, datetime, id }) => (
            <tr key={id}>
              <S.TransactionType>
                <TransactionTypeBadge t={t} transactionType={category} />
              </S.TransactionType>
              <S.TransactionDate>{`${dayjs.utc(datetime).format('DD.MM.YYYY HH:mm')}`}</S.TransactionDate>
              <S.TransactionMessage>
                {getTHistoryDescriptionTranslations(title, category, t)}
              </S.TransactionMessage>
            </tr>
          ))}
        </tbody>
      )}
    </S.TransactionsList>
  );
};
